import { render, staticRenderFns } from "./Rankings_List_Posts.vue?vue&type=template&id=8a8ba88c&"
import script from "./Rankings_List_Posts.vue?vue&type=script&lang=js&"
export * from "./Rankings_List_Posts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports